module.exports = __webpack_public_path__ + "static/img/top@2x.a98c5e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/myCenter/top@2x.png
// module id = 1055
// module chunks = 67